module.exports = {
	"search route": "Caută rută",
	"search train": "Caută tren",
	"train number": "Număr tren",
	"report error": "Raportează o eroare",
	"fastest": "cel mai rapid",
	"search": "Caută",
	"search on infofer": "Caută/cumpără pe site-ul CFR",
	"reverse": "Întoarcere",
	"from": "De la",
	"to": "Până La",
	"only direct routes": "Arată doar rutele directe",
	"no trains": "Caută o rută selectând staţiile de plecare şi destinaţie, sau selectând un număr de tren",
	"footer disclaimer": "Acceleratul este în <strong>beta</strong> şi nu îşi asumă nicio responsabilitate pentru eventualele probleme apărute din cauza unor date posibil incomplete sau incorecte. Preturile se refera la tariful intreg la clasa a II-a, cu loc, si sunt aproximari. Pentru preturi exacte, sunati la informatii folosind butonul din dreapta jos.",
	"footer contact": "Dacă ai pierdut trenul din cauza acestui site, înjură-mă aici:",
	"Delays last month": "Întârzieri în ultima lună",
	"delay": "întârziere",
	"time from": "de la",
	"time to": "până la",
	"wait for": "Aşteaptă",
	"and then": "şi după aceea",
	"just from": "doar din",
	"just to": "până în",
	"only": "",
	"weekdays": "în zile lucrătoare",
	"weekends": "în sfârşituri de saptamână",
	"monday": "luni",
	"tuesday": "marţi",
	"wednesday": "miercuri",
	"thursday": "joi",
	"friday": "vineri",
	"saturday": "sâmbătă",
	"sunday": "duminică",
	"january": "ianuarie",
	"february": "februarie",
	"march": "martie",
	"april": "aprilie",
	"may": "mai",
	"june": "iunie",
	"july": "iulie",
	"august": "august",
	"september": "septembrie",
	"october": "octombrie",
	"november": "noiembrie",
	"december": "decembrie",
	"costs": "costă",
	"lei": "lei",
	"DATE_BEFORE_MONTH": true
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/lang/ro.json
 ** module id = 295
 ** module chunks = 0
 **/